 /**
     * Cart Multiple Product Slider 
     * Cart Slick for mobile
     */
  $('.cart--MultipleProductsSlider .cart__cards').slick({
    mobileFirst: true,
    variableWidth: false,
    slidesToShow: 1,
    dots: true,
    speed: 300,
    centerMode: true,
    centerPadding: '50px',
    slidesToShow: 1,
    initialSlide: 1,
    responsive: [
        {
            breakpoint: 360,
            settings: {
                centerPadding: '12%',
            }
        },
        {
            breakpoint: 445,
            settings: {
                centerPadding: '15%',
            }
        },
        {
            breakpoint: 530,
            settings: {
                centerPadding: '18%',
            }
        },
        {
            breakpoint: 680,
            settings: {
                centerPadding: '28%',
            }
        },
        {
            breakpoint: 991,
            settings: 'unslick'
        }
    ]
});

/**
 * Handle products
 */
function cartMultipleProductsSliderActiveProduct() {
    let thisProduct = $(this);
    // console.log(thisProduct);

    const subscribe = $('#orderNow').attr('data-check');

    const retail = thisProduct.attr('data-retail');
    let amount, link, shipping, checkboxType;
    let units = thisProduct.attr('data-units');

    // console.log(subscribe);

    if (subscribe === 'subscribe') {
        amount = 'data-subscribe-amount';
        link = 'data-subscribe-tracker';
        shipping = 'data-subscribe-shipping';
        checkboxType = true;

    } else {
        amount = 'data-amount';
        link = 'data-tracker';
        shipping = 'data-shipping';
        checkboxType = false;
    }

    // console.log(thisProduct.attr(amount));
    // console.log(retail);
    // console.log((retail - thisProduct.attr(amount)).toFixed(2));

    //- Load given prices
    thisProduct.find('.amount__value').html(thisProduct.attr(amount));
    thisProduct.find('.shipping__value').html(thisProduct.attr(shipping));

    //- Calculate saving value
    thisProduct.find('.save__value').html(
        (thisProduct.attr(amount) / units).toFixed(2)
    );

    $('#orderNow.cart--MultipleProductsSlider').find('.purchaseMode__input').attr("checked", checkboxType);

    //- load tracker + param
    let param = thisProduct.find('.cta.btn').attr('data-param');
    
    // console.log(thisProduct.attr(link).includes('?'));
    // console.log(param);

    // if(thisProduct.attr(link).includes('?') == false) {
    //     param = '?' + param
    // } else {
    //     param = '&' + param
    // }

    thisProduct.find('.cta').attr('href', (thisProduct.attr(link) + param));
};

/**
 * Control Subscribe Mode
 */
 $('.cart--MultipleProductsSlider .purchaseMode__input').on('click', function (check) {
    handleSubscribe(this);
    // console.log($(this).is(":checked"));
});

function handleSubscribe(thisEL) {
    let checkboxType;
    
    if (thisEL == 'forceSubscribe') {
        checkboxType = true;
        $('#orderNow').attr('data-check', 'subscribe').find('.purchaseMode__input').attr("checked", checkboxType);

        // console.log($('.purchaseMode__input').is(":checked"));
        
    } else {
        if ($('#orderNow').attr('data-check') === 'un-subscribe') {
            checkboxType = true;
            $('#orderNow').attr('data-check', 'subscribe');
            
        } else {
            checkboxType = false;
            $('#orderNow').attr('data-check', 'un-subscribe')
        }

        thisEL.setAttribute('checked', checkboxType);
    }

    $('.card').each(cartMultipleProductsSliderActiveProduct);
}

$('.card').each(cartMultipleProductsSliderActiveProduct);
